<script>
import {mapMutations, mapState, mapActions, mapGetters} from 'vuex';
import MiniCart from '@/components/MiniCart';
import ToggleSwitch from '@/components/ToggleSwitch';
import AccountSelector from '@/components/account-selector/AccountSelector';
import VendorSelector from '@/components/vendor-selector/VendorSelector';
import NotificationsNav from '@/components/containers/notifications/NotificationsNav';
import NotificationsDropdown from '@/components/containers/notifications/NotificationsDropdown';

export default {
  components: {
    MiniCart,
    ToggleSwitch,
    AccountSelector,
    VendorSelector,
    NotificationsNav,
    NotificationsDropdown,
  },

  data() {
    return {
      showNav: false,
      mainNavItems: [
        {title: 'EQUIPMENT', url: '/b2b/us/en_US/c/B300'},
        {title: 'APPAREL', url: '#'},
        {title: 'RETAILERS SERVICES', url: '#'},
        {title: 'ORDERS', url: '#'},
        {title: 'NEWS', url: '#'},
      ],
      companyMenuItems: [
        {label: 'Profile', url: '#'},
        {label: 'Password', url: '#'},
        {label: 'Email address', url: '#'},
        {label: 'Payment details', url: '#'},
        {label: 'Saved lists', url: '#'},
        {label: 'Notification settings', url: '#'},
      ],
      accountMenuItems: [
        {label: 'Business Unit', url: '#'},
        {label: 'Users', url: '#'},
      ],
    };
  },

  computed: {
    showAdvancedOrderingToggle() {
      return this.isDistributor && !this.isDropShipFlagEnabled;
    },
    qaidValueHeaderColor() {
      return !this.consumerFriendlyMode ? 'site.preheader.color.gray' : 'site.preheader.color.blue';
    },

    ...mapState('user', ['loggedIn']),
    ...mapState('backend', [
      'consumerFriendlyMode',
      'isDistributor',
      'isDropShipFlagEnabled',
      'accountConsumerToggleAccess',
    ]),
    ...mapState('advancedOrdering', ['advancedOrderingMode']),
    ...mapGetters('notifications', ['notifications']),
  },

  watch: {
    // These two modes cannot be "on" at the same time
    consumerFriendlyMode(value) {
      if (value) this.setAdvancedOrderingMode(false);
    },
    advancedOrderingMode(value) {
      if (value) this.setConsumerFriendlyMode(false);
    },
  },

  created() {
    this.fetchNotifications(false);
  },

  methods: {
    ...mapActions('backend', ['toggleConsumerFriendlyMode', 'toggleAdvancedOrderingMode']),
    ...mapActions('advancedOrdering', ['toggleAdvancedOrderingMode']),
    ...mapMutations('backend', ['setConsumerFriendlyMode']),
    ...mapMutations('advancedOrdering', ['setAdvancedOrderingMode']),
    ...mapActions('notifications', ['fetchNotifications']),
  },
};
</script>
